import axios from 'axios';

export const GET_TEMPLATE_TIMELINE = 'GET_TEMPLATE_TIMELINE';
export const RESET_TEMPLATE_TIMELINE = 'RESET_TEMPLATE_TIMELINE';
export const SET_VARIABLE_IN_TEMPLATE_SETTINGS = 'SET_VARIABLE_IN_TEMPLATE_SETTINGS';
export const GET_CATEGORIES_SETTINGS = 'GET_CATEGORIES_SETTINGS';
export const SYNCHRONIZE_S3_FILES = 'SYNCHRONIZE_S3_FILES';

export function getTemplateTimelineR(templateId) {
  return {
    type: GET_TEMPLATE_TIMELINE,
    payload: axios.get(`/api/producttemplates/${templateId}/timeline.json`, {}).then(({ data }) => data),
  };
}

export function resetTemplateTimelineR(templateId, entryId) {
  return {
    type: RESET_TEMPLATE_TIMELINE,
    payload: axios.put(`/api/producttemplates/${templateId}/reset.json`, { resetTo: entryId }).then(({ data }) => data),
  };
}

export function setVariablesInTemplateSettings(key) {
  return {
    type: SET_VARIABLE_IN_TEMPLATE_SETTINGS,
    payload: key,
  };
}

export function getCategoriesSettingsR() {
  return {
    type: GET_CATEGORIES_SETTINGS,
    payload: axios.get(`/api/categories.json`, {}).then(({ data }) => data),
  };
}

export function synchronizeS3R(exportData, templateId) {
  return {
    type: SYNCHRONIZE_S3_FILES,
    payload: axios.put(`/api/producttemplates/${templateId}/sync.json`, exportData).then(({ data }) => data),
  };
}
